import React, { useState, useEffect } from "react";
import "./Encyclopedia.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

function Countries() {
  const { continent } = useParams();
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/v1/get-countries/${continent}`
      )
      .then((res) => {
        console.log(res);
        setCountries(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [continent]);

  return (
    <div className="countrie">
      <Header title="لیست کشور ها" />

      <div className="countries-body">
        {countries.length > 0 ? (
          countries.map((post) => (
            <Link to={`/countrysingle/${post._id}`} key={post._id}>
              <div className="countrie-box">
                <span>{post.country}</span>
                <div className="countrie-img">
                  <img src={post.img?.url} alt="Profile" />
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="spinner">
            <Loader
              type="TailSpin"
              color="rgb(236, 177, 28)"
              height={80}
              width={80}
            />
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default Countries;